export default {
	API: "/api"
};
